import { render } from "./TBN.vue?vue&type=template&id=dc3a5a5e"
import script from "./TBN.vue?vue&type=script&lang=js"
export * from "./TBN.vue?vue&type=script&lang=js"

import "./TBN.vue?vue&type=style&index=0&id=dc3a5a5e&lang=css"
script.render = render

export default script